export enum ExamDay {
  MON = 'MON',
  TUE = 'TUE',
  WED = 'WED',
  THU = 'THU',
  FRI = 'FRI',
  SAT = 'SAT',
  SUN = 'SUN',
}

export enum EventEndType {
  ON_EXAM_DATE = 'ON_EXAM_DATE',
  BEFORE_EXAM_DATE = 'BEFORE_EXAM_DATE',
}
